import { StyleSheet } from '@react-pdf/renderer';

import { palette } from '../../assets/styles/themes/tokens';

const FIGMA_DESIGN_WIDTH_IN_PX = 2480;
const A4_WIDTH_IN_MM = 210;

export const pxToMm = (px: number) =>
	`${((px / FIGMA_DESIGN_WIDTH_IN_PX) * A4_WIDTH_IN_MM).toFixed(2)}mm`;

const styles = StyleSheet.create({
	page: {
		backgroundColor: '#F2F7FF',
		flexDirection: 'row',
		height: '100%',
		padding: 0,
		fontFamily: 'Borna',
		color: palette.text.primary,
	},
	imageContainer: {
		width: pxToMm(449),
		height: '100%',
		backgroundColor: '#CCE0FF',
	},
	image: {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
	},
	container: {
		width: pxToMm(2031),
	},
	main: {
		paddingTop: pxToMm(251),
		paddingLeft: pxToMm(236),
		paddingRight: pxToMm(236),
	},
	header: {
		fontSize: pxToMm(40),
		paddingBottom: pxToMm(400),
		fontWeight: 500,
	},
	text: {
		fontSize: pxToMm(46),
		lineHeight: 1.6,
	},
	userName: {
		fontSize: pxToMm(150),
		paddingBottom: pxToMm(120),
		fontWeight: 500,
		lineHeight: 0.9,
	},
	courseTitle: {
		fontSize: pxToMm(90),
		paddingBottom: pxToMm(30),
		fontWeight: 500,
		lineHeight: 1.3,
	},
	footer: {
		flexDirection: 'column',
		width: '100%',
		position: 'absolute',
		bottom: 0,
		right: 0,
		paddingLeft: pxToMm(236),
		paddingRight: pxToMm(236),
		paddingBottom: pxToMm(123),
	},
	logo: {
		position: 'absolute',
		bottom: 0,
		right: 0,
		width: pxToMm(203),
		height: pxToMm(203),
	},
	footerTextContainer: {
		flexDirection: 'row',
		gap: pxToMm(60),
		alignItems: 'center',
	},
	klettLogo: {
		width: pxToMm(614),
		height: pxToMm(58),
		flexShrink: 0,
	},
	certifiedAtText: {
		fontWeight: 600,
		fontSize: pxToMm(40),
		paddingTop: pxToMm(30),
		lineHeight: 1.575,
	},
	footerDetails: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: pxToMm(320),
	},
	signatureContainer: {
		alignItems: 'center',
		paddingTop: pxToMm(155),
		position: 'relative',
	},
	withSeparator: {
		width: pxToMm(703),
		borderTop: pxToMm(1),
		borderColor: '#493666',
		borderTopStyle: 'solid',
		paddingTop: pxToMm(90),
	},
	signatureImage: {
		width: pxToMm(450),
		height: pxToMm(250),
		position: 'absolute',
		left: pxToMm(200),
		top: 0,
	},
	signatureText: {
		fontSize: pxToMm(40),
		lineHeight: 1.575,
		textAlign: 'center',
	},
	footerText: {
		fontSize: pxToMm(31),
		lineHeight: 1.29,
	},
});

export default styles;
